import http from '~/common/http'
export default {
    // 成交订单分析统计
    getList(params) {
        return http.get('/api/area-group/index', {
            params: params
        });
    },
    create(params) {
        return http.post("/api/area-group/create", params);
    },

    update(params) {
        return http.put("/api/area-group/update", params);
    },

    delete(id) {
        return http.delete("/api/area-group/delete", {
            params: {
                id: id
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/areaGroup.js